import React from 'react'
import PropTypes from 'prop-types'
import {Typography} from '@material-ui/core'

const NoOptionsMessage = React.memo(
  ({classes, selectedOptionsLength, allOptionsLength, ...props}) => {
    return (
      <Typography className={classes.noOptionsMessage} {...props.innerProps}>
        {selectedOptionsLength === allOptionsLength
          ? 'No options'
          : 'No results found... try a new search'}
      </Typography>
    )
  },
)

NoOptionsMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedOptionsLength: PropTypes.number.isRequired,
  allOptionsLength: PropTypes.number.isRequired,
  innerProps: PropTypes.object,
}

export default NoOptionsMessage
